import { Component } from 'react'

class SkeletonHome extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: '',
      floatMenu: false,
      width: 0,
      height: 0,
      flagPotraitPhone: false
    }
  }

  componentDidMount = async () => {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight })
    // console.log('innerWidth = ' + window.innerWidth)
    // console.log('innerHeight = ' + window.innerHeight)
    if (window.innerWidth < 500 && window.innerHeight > 650) {
      // console.log("disini")
      this.setState({ flagPotraitPhone: true })
    } else if (window.innerWidth > 700 && window.innerHeight > 500) {
      // console.log("disini 1")
      this.setState({ flagPotraitPhone: true })
    } else {
      // console.log("disini 2")
      this.setState({ flagPotraitPhone: false })
    }
    // console.log('innerWidth = ' + this.state.width)
    // console.log('innerHeight = ' + this.state.height)
  }

  render() {
    return (
      <div>
        {/* <!-- Hero Section --> */}
        <div className="fixed w-full top-0 left-0 p-4 pb-10 bg-gray-300">
          <div className="animate-pulse">
            <div className="w-32 h-8 mb-3 bg-gray-100 rounded-full"></div>
            <div className="flex">
              <div className="w-6 h-5 mr-2 bg-gray-100 rounded-full"></div>
              <div className="w-72 h-5 bg-gray-100 rounded-full"></div>
            </div>
            <div className="grid grid-cols-2 gap-2">
              <div className="mt-4 p-4 w-42 h-28 bg-gray-100 rounded-2xl"></div>
            </div>
            {/* <div className="flex mt-3">
              <div className="mr-1 w-28 h-4 bg-gray-100 rounded-full"></div>
              <div className="w-12 h-4 bg-gray-100 rounded-full"></div>
            </div> */}
          </div>
        </div>
        {/* <!-- End Hero Section --> */}
        {/* <!-- Main Content Wrap --> */}
        <div className="relative mt-[250px] sm:mt-[280px] md:mt-[250px] bg-white z-10 before:absolute before:top-[-25px] before:left-0 before:w-full before:h-[25px] before:bg-white before:rounded-t-2xl after:absolute after:w-20 after:h-1 after:top-[-14px] after:left-[38%] after:sm:left-[44%] after:bg-gray-100 after:rounded-full">
          {/* <!-- Titel Section --> */}
          <div className="flex justify-between px-4 items-center mt-4 mb-2 animate-pulse">
            <div className="w-28 h-4 bg-gray-300 rounded-full"></div>
            <div className="w-20 h-4 bg-gray-300 rounded-full"></div>
          </div>
          {/* <!-- End Title Section --> */}
          <div className="pl-4">
            <div className="flex overflow-hidden">
              {/* <!-- Item Book --> */}
              <div className="p-1">
                <div className="w-[100px] h-[258px] sm:w-[197px] sm:h-[258px] rounded-xl shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer">
                  <div className="h-[130px] overflow-hidden animate-pulse">
                    <div className="w-full h-[150px] bg-gray-300 rounded-xl"></div>
                  </div>
                  <div className="p-2 min-h-[120px] animate-pulse">
                    <div className="w-20 h-3 mt-3 bg-gray-300 rounded-full"></div>
                    <div className="w-16 h-3 mt-2 bg-gray-300 rounded-full"></div>
                    <div className="w-12 h-3 mt-2 bg-gray-300 rounded-full"></div>
                  </div>
                </div>
              </div>
              {/* <!-- End Item Book --> */}
              {/* <!-- Item Book --> */}
              <div className="p-1">
                <div className="w-[100px] h-[258px] sm:w-[197px] sm:h-[258px] rounded-xl shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer">
                  <div className="h-[130px] overflow-hidden animate-pulse">
                    <div className="w-full h-[150px] bg-gray-300 rounded-xl"></div>
                  </div>
                  <div className="p-2 min-h-[120px] animate-pulse">
                    <div className="w-20 h-3 mt-3 bg-gray-300 rounded-full"></div>
                    <div className="w-16 h-3 mt-2 bg-gray-300 rounded-full"></div>
                    <div className="w-12 h-3 mt-2 bg-gray-300 rounded-full"></div>
                  </div>
                </div>
              </div>
              {/* <!-- End Item Book --> */}
              {/* <!-- Item Book --> */}
              <div className="p-1">
                <div className="w-[100px] h-[258px] sm:w-[197px] sm:h-[258px] rounded-xl shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer">
                  <div className="h-[130px] overflow-hidden animate-pulse">
                    <div className="w-full h-[150px] bg-gray-300 rounded-xl"></div>
                  </div>
                  <div className="p-2 min-h-[120px] animate-pulse">
                    <div className="w-20 h-3 mt-3 bg-gray-300 rounded-full"></div>
                    <div className="w-16 h-3 mt-2 bg-gray-300 rounded-full"></div>
                    <div className="w-12 h-3 mt-2 bg-gray-300 rounded-full"></div>
                  </div>
                </div>
              </div>
              {/* <!-- End Item Book --> */}
              {/* <!-- Item Book --> */}
              <div className="p-1">
                <div className="w-[100px] h-[258px] sm:w-[197px] sm:h-[258px] rounded-xl shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer">
                  <div className="h-[130px] overflow-hidden animate-pulse">
                    <div className="w-full h-[150px] bg-gray-300 rounded-xl"></div>
                  </div>
                  <div className="p-2 min-h-[120px] animate-pulse">
                    <div className="w-20 h-3 mt-3 bg-gray-300 rounded-full"></div>
                    <div className="w-16 h-3 mt-2 bg-gray-300 rounded-full"></div>
                    <div className="w-12 h-3 mt-2 bg-gray-300 rounded-full"></div>
                  </div>
                </div>
              </div>
              {/* <!-- End Item Book --> */}
            </div>
          </div>

          {/* <!-- Category --> */}
          <div className="grid grid-cols-3 gap-2 mt-4 px-4 animate-pulse">
            <div className="w-full h-12 bg-gray-300 rounded-lg"></div>
            <div className="w-full h-12 bg-gray-300 rounded-lg"></div>
            <div className="w-full h-12 bg-gray-300 rounded-lg"></div>
            <div className="w-full h-12 bg-gray-300 rounded-lg"></div>
            <div className="w-full h-12 bg-gray-300 rounded-lg"></div>
            <div className="w-full h-12 bg-gray-300 rounded-lg"></div>
          </div>
          {/* <!-- End Category --> */}
        </div>
        {/* <!-- End Main Content Wrap --> */}
        {/* <!-- Bottom Menu --> */}
        {this.state.flagPotraitPhone && (
          <div className="fixed bottom-0 w-full bg-white rounded-t-2xl py-3 drop-shadow-[0_35px_35px_rgba(0,0,0,0.25)] z-50">
            <div className="grid grid-cols-5">
              <div className="flex justify-center items-center">
                <center>
                  <div className="flex flex-col animate-pulse">
                    <div>
                      <div className="w-6 h-6 bg-gray-300 rounded-lg"></div>
                    </div>
                    <div className="w-12 h-3 mt-1 bg-gray-300 rounded-full"></div>
                  </div>
                </center>
              </div>
              <div className="flex justify-center items-center">
                <center>
                  <div className="flex flex-col animate-pulse">
                    <div>
                      <div className="w-6 h-6 bg-gray-300 rounded-lg"></div>
                    </div>
                    <div className="w-12 h-3 mt-1 bg-gray-300 rounded-full"></div>
                  </div>
                </center>
              </div>
              <div className="flex justify-center items-center animate-pulse">
                <center>
                  <div className="flex flex-col relative">
                    <div className="w-[52px] h-[52px] bg-gray-300 rounded-full drop-shadow-md p-3 items-center absolute top-[-35px] left-[-1px]"></div>
                    <div className="w-12 h-3 mt-[29px] bg-gray-300 rounded-full"></div>
                  </div>
                </center>
              </div>
              <div className="flex justify-center items-center">
                <center>
                  <div className="flex flex-col animate-pulse">
                    <div>
                      <div className="w-6 h-6 bg-gray-300 rounded-lg"></div>
                    </div>
                    <div className="w-12 h-3 mt-1 bg-gray-300 rounded-full"></div>
                  </div>
                </center>
              </div>
              <div className="flex justify-center items-center">
                <center>
                  <div className="flex flex-col animate-pulse">
                    <div>
                      <div className="w-6 h-6 bg-gray-300 rounded-lg"></div>
                    </div>
                    <div className="w-12 h-3 mt-1 bg-gray-300 rounded-full"></div>
                  </div>
                </center>
              </div>
            </div>
          </div>
        )}
        {/* <!-- End Bottom Menu --> */}
        <div className={this.state.width > '650' && this.state.height < '500' && 'fixed bottom-6 right-6 z-50 h-14 w-14 bg-gray-300 animate-pulse rounded-full items-center shadow-lg block'}></div>
        <div className={this.state.width < '500' && this.state.height > '650' && 'fixed bottom-6 right-6 z-50 h-14 w-14 bg-gray-300 animate-pulse rounded-full items-center shadow-lg hidden'}></div>
      </div>
    )
  }
}

export default SkeletonHome
